import { Globe2, TrendingUp, Users } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const destinations = [
  {
    name: "Australia & New Zealand",
    note: "Interested in mining engineering or marine and environmental sciences? Explore Australia. Drawn to food science, agriculture or agritech? Consider New Zealand. We help you connect your interests with courses and research opportunities that support your ambitions.",
    img: "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?auto=format&fit=crop&w=1200&q=85",
  },
  {
    name: "UK, Ireland, USA & Canada",
    note: "Interested in healthcare or robotics? Explore the UK. Drawn to computing or pharmaceutical sciences? Consider Ireland. Explore engineering and computer science in the USA, or AI and applied technology in Canada. Your interests help us shape the shortlist.",
    img: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1200&q=85",
  },
  {
    name: "Malaysia, Thailand, UAE & Beyond",
    note: "Dreaming of a career in hospitality or tourism? Explore Thailand. Interested in business or engineering? Consider Malaysia. Drawn to logistics, finance or international business? Explore the UAE. Discover study options closer to home that connect with your ambitions.",
    img: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=1200&q=85",
  },
];

const values = [
  { icon: Globe2, text: "Global exposure that expands your worldview" },
  { icon: TrendingUp, text: "Destinations mapped to emerging employment needs" },
  { icon: Users, text: "Guidance shaped by first-hand international experience" },
];

export const Destinations = () => (
  <section
    id="destinations"
    data-testid="destinations-section"
    className="relative pt-8 pb-20 lg:pt-12 lg:pb-28 bg-[#FFFFFF]"
  >
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
        <Reveal>
          <Overline testid="destinations-overline">Global opportunities</Overline>
          <h2
            data-testid="destinations-heading"
            className="mt-6 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-[#111111] max-w-xl"
          >
            Where will your ambitions take you?
          </h2>
        </Reveal>
      </div>

      <div className="mt-10 lg:mt-14 grid md:grid-cols-3 gap-6">
        {destinations.map((d, i) => (
          <Reveal key={d.name} delay={i * 0.12}>
            <article
              data-testid={`destination-card-${i}`}
              className="group relative rounded-3xl overflow-hidden h-[26rem] cursor-pointer"
            >
              <img
                src={d.img}
                alt={d.name}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#111111]/90 via-[#111111]/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <span className="text-xs uppercase tracking-[0.25em] font-bold text-[#FE7815]">
                  0{i + 1}
                </span>
                <h3 className="mt-2 text-xl sm:text-2xl font-semibold text-white">
                  {d.name}
                </h3>
                <p className="mt-2 text-sm text-white/70 max-w-xs opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
                  {d.note}
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <div className="mt-14 grid sm:grid-cols-3 gap-6">
        {values.map((v, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div
              data-testid={`destination-value-${i}`}
              className="flex items-center gap-4"
            >
              <div className="w-10 h-10 shrink-0 rounded-xl bg-gradient-to-br from-[#FE7815]/10 to-[#F01E1F]/10 flex items-center justify-center">
                <v.icon className="w-5 h-5 text-[#FE7815]" strokeWidth={2.2} />
              </div>
              <p className="text-sm font-medium text-[#111111]">{v.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
